import { defineComponent, reactive, computed } from 'vue';
import { Tooltip } from '@hems/component';
export default defineComponent({
    name: 'ApplianceStatusBox',
    components: {
        Tooltip,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    setup(props) {
        const state = reactive({
            data: computed(() => props.data),
        });
        return {
            state,
        };
    },
});
